import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'
import MeetingButtonSection from './MeetingButtonSection'
import MeetingSchedule from './MeetingSchedule'
import MeetingStatusSection from './MeetingStatusSection'
import MeetingUserImage from './MeetingUserImage'
import dateTimeFormat from '../utils/dateTimeFormat'
import StandardModal from '../app_components/StandardModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'


class MeetingListItem extends React.Component {
  constructor(props) {
    super(props)

    this.renderMeetingImage = this.renderMeetingImage.bind(this)
    this.renderMeetingItem = this.renderMeetingItem.bind(this)
    this.renderResponseForm = this.renderResponseForm.bind(this)
    this.renderCancelForm = this.renderCancelForm.bind(this)
    this.navigateToEditMeeting = this.navigateToEditMeeting.bind(this)

    this.state = {
      otherUser: [],
      currentUser: [],
      openResponseForm: false,
      openCancelForm: false,
    }
  }

  componentDidMount() {
    if(this.props.item.requestee.id === this.props.currentUser.id) {
      this.setState({
        otherUser: this.props.item.requestor,
        currentUser: this.props.item.requestee
      })
    } else {
      this.setState({
        otherUser: this.props.item.requestee,
        currentUser: this.props.item.requestor
      })
    }
  }

  renderResponseForm() {
    this.setState({
      openResponseForm: !this.state.openResponseForm
    })
  }

  renderCancelForm() {
    this.setState({ openCancelForm: !this.state.openCancelForm })
  }

  navigateToEditMeeting() {
    this.props.navigation.navigate("MeetingForm", {
      meeting: this.props.item,
    })
  }

  componentWillMount() {
    this.setState({
      openResponseForm: false,
      openCancelForm: false,
    })
  }

  renderMeetingImage() {
    if(this.state.otherUser !== []) {
        return(
          <div >
            <MeetingUserImage
              otherUser={this.state.otherUser}
            />
            <FontAwesomeIcon
              icon={faArrowLeft}
              style={{color: '#151E25', fontSize: 10, marginBottom: 20}}
            />
            <FontAwesomeIcon
              icon={faArrowRight}
              style={{color: '#151E25', fontSize: 10, marginBottom: 20}}
            />
            <MeetingUserImage
              otherUser={this.state.currentUser}
            />
          </div>
        )
    }
  }


  renderMeetingItem() {
    let today = parseInt(moment(new Date()).format('YYYYMMDD'))
    const { meeting_time, location, location_address, lang_one, lang_two, requestor, requestee, id } = this.props.item

    if(this.props.currentUser) {
    return(
      <div className="meetingItemContainer" style={{width: 650, maxWidth: '90%', marginTop: 20}} key={id}>
        <MeetingStatusSection
          item={this.props.item}
          currentUser={this.props.currentUser}/>
        <div className="meetingItemInfoContianer" >
            <div className="meetingItemDate">
              <h1>{moment(meeting_time).format("ddd")}</h1>
              <h1>{moment(meeting_time).format("MMM D")}</h1>
              <div style={{marginTop: 10}}>
                <h5 className="sectionText">{moment(meeting_time).format("h:mm a")} <span className="bold">at {location}</span></h5>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className="darkBlue"
                    style={{fontSize: 10,  marginRight: 5}}
                  />
                  <h5 className="bold darkBlue">{location_address}</h5>
                </div>
              </div>
            </div>
            <div className="meetingItemLanguages">
              {this.renderMeetingImage()}
              <MeetingSchedule
                meeting_time={meeting_time}
                lang_one={lang_one}
                lang_two={lang_two}
                currentUser={this.props.currentUser}
              />
            </div>
        </div>
        {(this.props.item.status === "Active" && this.props.passed != true) &&
        <MeetingButtonSection
          meeting={this.props.item}
          currentUser={this.props.currentUser}
          renderResponseForm={this.renderResponseForm}
          renderCancelForm={this.renderCancelForm}
          getAllMeetings={this.props.getAllMeetings}
           />}
      </div>
    )
  } else {
    return null
  }
}
// <ButtonSection
//   meeting={this.props.item}
//   navigate={this.props.navigation}
//   currentUser={this.props.currentUser}
//   renderResponseForm={this.renderResponseForm}
//   renderCancelForm={this.renderCancelForm}
// />

  render() {
    return (
      <div>
        {this.renderMeetingItem()}
      </div>
    )
  }

}

export default MeetingListItem;
